import React                from 'react';
import { Modal, Button }    from 'react-bootstrap';

import { ICON_CANCEL }      from '../../../../extras/icons';



const AccusedResultInfo = props => {
    
    // Tomo los props
    const { accused, audience, handleClose, show } = props;
    
    // Renderizo
    return (
        <Modal            
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleClose} 
            show = { show} 
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Resultado Imputado: <strong>{ accused.persona.apellido + ', ' + accused.persona.nombre}</strong> 
                    <br/>
                    <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {   accused.resultado &&
                        <div className="row">
                            <div className="col-12">
                                <table className="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td className="align-middle">Resultado</td>
                                            <td className="align-middle">
                                                <strong>{ accused.resultado.descripcion }</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="align-middle">Observaciones</td>
                                            <td className="align-middle">
                                                <strong>{ accused.resultadoObs }</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="align-middle">Plazo</td>
                                            <td className="align-middle">
                                                <strong>{ accused.plazo }</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="align-middle">Modalidad</td>
                                            <td className="align-middle">
                                                <strong>{ accused.modalidad?.descripcion || '' }</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AccusedResultInfo;